import React from 'react';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';

import usePlans from 'components/Common/Affiliates/Hooks/usePlans';
import columns from './columns';

export default function Table({ affiliateId }) {
  const { plans } = usePlans(affiliateId);

  return (
    <div className="datatable-style">
      <DataTable
        title=""
        columns={columns}
        data={plans || []}
        noDataComponent={(
          <div className="mt20">
            {plans == null
              ? 'Please, wait ...'
              : 'No matching records found'}
          </div>
          )}
        persistTableHead
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: 'All',
        }}
      />
    </div>
  );
}

Table.propTypes = {
  affiliateId: PropTypes.number.isRequired,
};
